import { makeAutoObservable } from "mobx";
import { Message } from "components/MessageSummary/Message";

export class MessageStore {
  message: Message | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  successMessage(
    message: string,
    toastify: boolean = true,
    life: number = 5000
  ) {
    this.message = {
      severity: "success",
      detail: message,
      life: life,
      toastify: toastify,
    };
  }

  infoMessage(message: string, toastify: boolean = true, life: number = 5000) {
    this.message = {
      severity: "info",
      detail: message,
      life: life,
      toastify: toastify,
    };
  }

  warningMessage(
    message: string,
    toastify: boolean = true,
    life: number = 5000
  ) {
    this.message = {
      severity: "warn",
      detail: message,
      life: life,
      toastify: toastify,
    };
  }

  errorMessage(message: string, toastify: boolean = true, life: number = 5000) {
    this.message = {
      severity: "error",
      detail: message,
      life: life,
      toastify: toastify,
    };
  }

  clear() {
    this.message = null;
  }
}
